import React, { ReactElement } from 'react';
import useWindowSize from '../../../customHooks/useWindowSize';
import classes from './TermsAgreementModal.module.css';
import EmptyModal from './../EmptyModal';
import Button from '../../Button/Button';
import { PrivacyPolicy, TermsOfUse } from '../../../utils/globalVariables';
import axios, { AxiosError } from "axios";
import { ugUserApiUrl } from '../../../endpoints/endpoints';
import { useStore } from '../../../useStore';
import { CloseAllModal } from '../../../utils/CloseAllModal';
import Alert from '@mui/material/Alert';
import { useOnError } from '../../../customHooks/useOnError';
import { HeaderDTO } from '../../../utils/interface';
import { useGet_HeaderData } from '../../../containers/PlantInformation/DashboardHttpServices';

const TermsAgreementModal: React.FC = () => {
  const { isMobile } = useWindowSize();
  const {
    setIsModal,
    setHeader,
    isModal,
    header: {
      data: { user }
    }
  } = useStore();

  let width: number = 600;
  if (isMobile) {
    width = 300;
  }

  let modalBody: ReactElement | undefined;
  let modalFooter: ReactElement | undefined;


  const handleAgreeToTerms = async () => {
    try {
      await axios.put(`${ugUserApiUrl}/renewagreement/${user.userId}`);
      setIsModal?.({
        ...CloseAllModal
      });
      refreshHeaderData(); // Refresh header data to reflect the agreement renewal
    } catch (error) {
      console.error('Failed to renew agreement:', error);
    }
  };
  
  const setErrorData = useOnError();
  const onSuccess = (data: HeaderDTO) => {
    setHeader?.(data);
  };
  const onError = (error: AxiosError<string>) => {
    setErrorData(error);
  };

  const { refetch: refreshHeaderData } = useGet_HeaderData(onSuccess, onError);


    modalBody = (
      <>

        <div className="grid gap-4 grid-cols-1">
        <Alert severity="warning">To proceed, please review and agree to our terms of use and privacy policy.</Alert>
          <div className="flex flex-col gap-2">
            <a
              href={TermsOfUse}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 underline"
            >
              View Terms of Use
            </a>
            <a
              href={PrivacyPolicy}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 underline"
            >
              View Privacy Policy
            </a>
          </div>
        </div>
      </>
    );

    modalFooter = (
      <>
        <div className="flex flex-row items-start gap-4">
          <Button
            className="darkBlue text-xs md:text-base h-9 md:h-11 px-3 md:px-10 md:py-2.5"
            text="I Agree"
            onClick={handleAgreeToTerms}
          />
        </div>
      </>
    );

  return (
    <EmptyModal
      shown={isModal.isTermsAgreement.agreementExpired}
      body={modalBody}
      footer={modalFooter}
      heading="Terms of Use and Privacy Policy"
      onClose={() => {}}
      width={width}
      footerClass={classes.modal_footer}
      allowClose={false} // Disable close icon for this modal to ensure user agrees to terms
      
    />
  );
};

export default TermsAgreementModal;